import { ErrorHandler } from '@angular/core';
import { ReloadErrorHandler } from '@utils/errorHandler/reloadErrorHandler';
import { SentryErrorHandler } from '@utils/errorHandler/sentryErrorHandler';

export const ERROR_HANDLER_DEPENDENCIES = [
    ReloadErrorHandler,
    SentryErrorHandler,
];

export class GlobalErrorHandler implements ErrorHandler {
    private _handlers: ErrorHandler[];

    constructor(
        reloadErrorHandler: ReloadErrorHandler,
        sentryErrorHandler: SentryErrorHandler,
    ) {
        this._handlers = [
            reloadErrorHandler,
            sentryErrorHandler,
        ];
    }

    handleError(error: any) {
        this._handlers
            .forEach((handler) => handler.handleError(error));
    }
}
